<p-dataView
    class="dataview"
    styleClass="custom-scrollbar"
    [ngClass]="{
        'dataview_without-content':
            state == 'noproposals' || (proposals && proposals.length && proposals[0].lastDeleted) || (proposals && !proposals.length)
    }"
    [value]="proposals"
    layout="grid"
    [rows]="40"
    [paginator]="true"
    (wheel)="onScroll()"
>
    <ng-template let-proposal pTemplate="gridItem">
        <div class="dataview__item" (click)="editComment(proposal)">
            <img *ngIf="proposal.isImage" class="item__attachment_type_image" [src]="getProposalSrc(proposal)" />
            <span *ngIf="proposal.isVideo" class="item__attachment_type_video"></span>
            <span *ngIf="!proposal.isImage && !proposal.isVideo" class="item__attachment_type_document"></span>

            <div class="item__description">
                <div class="description__date">
                    <span class="date__icon">
                        <i class="fa-light fa-clock-nine"></i>
                    </span>
                    <span class="date__text">נוסף ב: {{ proposal.dateProposalText }}</span>
                </div>
                <span *ngIf="proposal.comments" class="description__comment">{{ proposal.comments }}</span>
            </div>

            <button class="item__button_mobile" (click)="toggleSubMenu($event, menu, proposal, true)">
                <i class="fa-solid fa-ellipsis-vertical"></i>
            </button>
            <button class="item__button" (click)="toggleSubMenu($event, menu, proposal, false)">
                <i class="fa-solid fa-ellipsis-vertical"></i>
            </button>
            <p-menu #menu class="item__menu action-list" [model]="attachmentItems" [popup]="true"></p-menu>
        </div>
    </ng-template>
</p-dataView>

<label class="button button_with-icon button_icon-only button_theme_main add-button">
    <i class="fa-solid fa-plus"></i>
    <input #uploadInput class="add-button__input" type="file" multiple (change)="uploadDocument($event)" />
</label>

<div
    *ngIf="state == 'noproposals' || (proposals && proposals.length && proposals[0].lastDeleted) || (proposals && !proposals.length)"
    class="dataview__empty-wrapper"
>
    <h3 class="dataview__empty-title">אין עדיין תמונות/קבצים בגלריה</h3>
    <span class="dataview__empty-text">להוספת תמונה או קובץ חדש לחץ על הכפתור פלוס הכחול שבתחתית המסך</span>
    <span class="dataview__empty-image"></span>
</div>

<p-dialog
    [ngClass]="{ 'custom-dialog': isConfirmDialogVisible }"
    styleClass="modal modal_type_confirm"
    [(visible)]="isConfirmDialogVisible"
    header="אזהרה"
    [modal]="true"
    [resizable]="false"
    [draggable]="false"
>
    <div class="modal__text">האם אתם בטוחים שברצונכם למחוק את התמונה/הקובץ?</div>
    <div class="modal__footer">
        <button class="button button_size_small button_theme_gray-line" (click)="closeConfirmDialog(false)">ביטול</button>
        <button class="button button_size_small button_theme_main" (click)="closeConfirmDialog(true)">מחיקה</button>
    </div>
</p-dialog>

<p-dialog
    [ngClass]="{ 'custom-dialog': isCardMenuOpened }"
    styleClass="modal modal_type_menu modal_card-menu"
    [(visible)]="isCardMenuOpened"
    header="פעולות נוספות"
    [modal]="true"
    [resizable]="false"
    [draggable]="false"
    transitionOptions="0ms"
>
    <button
        *ngFor="let item of attachmentItems"
        class="menu-button {{ item.icon }} button button_with-icon"
        (click)="item.command()"
        [disabled]="item.disabled"
    >
        {{ item.label }}
    </button>
</p-dialog>

<p-messages class="messages"></p-messages>

<div
    appHostListenerBeforeUnload
    #hostListenerBeforeUnload="hostListenerBeforeUnload"
    (componentHasChangedOutput)="this.componentHasChanged = $event"
    [saveData]="saveData"
    [receivedData]="proposals"
></div>
